import React, {
    useEffect,
    useMemo,
    useState,
  } from "react";
  
  import {
    collection,
    getDocs,
    addDoc,
    query,
    where,
    serverTimestamp,
  } from "firebase/firestore";
  
  import { db } from "../firebase";
  
  import "./AdminMonthlyBonus.css";
  
  
  /* =========================================================
     MONTHLY BONUS SETTINGS
  ========================================================= */
  
  const MIN_LEVEL1 = 5;
  const MIN_LEVEL1_DEPOSIT_TZS = 30000;
  const MIN_USER_DEPOSITS = 2;
  
  
  /* =========================================================
     COUNTRY → CURRENCY
  ========================================================= */
  
  const countryCurrency = {
    Kenya: "KES",
    Uganda: "UGX",
    Rwanda: "RWF",
    Burundi: "BIF",
    "DRC - Congo": "USD",
    Zambia: "ZMW",
    Malawi: "MWK",
    Mozambique: "MZN",
    Zimbabwe: "USD",
    "South Sudan": "SSP",
    Botswana: "BWP",
    Madagascar: "MGA",
  };
  
  
  /* =========================================================
     CURRENCY → TZS RATE
  ========================================================= */
  
  const currencyRates = {
    Kenya: 21.5,
    Uganda: 0.77,
    Rwanda: 1.9,
    Burundi: 0.94,
    "DRC - Congo": 2762.43,
    Zambia: 147.23,
    Malawi: 1.382,
    Mozambique: 43.71,
    Zimbabwe: 2762.43,
    "South Sudan": 0.469,
    Botswana: 211.95,
    Madagascar: 0.684,
  };
  
  
  /* =========================================================
     FORMAT NUMBER
  ========================================================= */
  
  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString();
  };
  
  
  /* =========================================================
     CONVERT TO TZS
  ========================================================= */
  
  const convertToTZS = (
    amount,
    country,
    currency = null
  ) => {
  
    const numericAmount =
      Number(amount || 0);
  
    if (!numericAmount) {
      return 0;
    }
  
  
    /*
     * Visitor deposit
     * tunatumia country rate.
     */
  
    if (country && currencyRates[country]) {
      return Math.round(
        numericAmount *
        currencyRates[country]
      );
    }
  
  
    /*
     * TSH transaction
     */
  
    if (
      currency === "TZS" ||
      currency === "TSH" ||
      currency === "TZ"
    ) {
      return numericAmount;
    }
  
  
    /*
     * USDT
     *
     * Hapa hatuitengenezi conversion ya USDT
     * kuwa TZS kwa sababu rate yake haipo kwenye
     * code yako ya sasa.
     *
     * USDT deposits zitaonekana lakini hazitaingia
     * kwenye qualified TZS deposit bila rate.
     */
  
    return 0;
  };
  
  
  /* =========================================================
     DATE HELPERS
  ========================================================= */
  
  const parseDate = (value) => {
  
    if (!value) {
      return null;
    }
  
  
    if (
      typeof value?.toDate === "function"
    ) {
      return value.toDate();
    }
  
  
    if (
      typeof value?.seconds === "number"
    ) {
      return new Date(
        value.seconds * 1000
      );
    }
  
  
    if (value instanceof Date) {
      return value;
    }
  
  
    const date = new Date(value);
  
    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return null;
    }
  
    return date;
  };
  
  
  const getTransactionDate = (item) => {
  
    return (
      parseDate(item.createdAt) ||
      parseDate(item.timestamp) ||
      parseDate(item.paidAt) ||
      parseDate(item.date)
    );
  
  };
  
  
  /* =========================================================
     MONTH KEY
  ========================================================= */
  
  const getMonthKey = (date) => {
  
    const year =
      date.getFullYear();
  
    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");
  
    return `${year}-${month}`;
  };
  
  
  /* =========================================================
     MONTH RANGE
  ========================================================= */
  
  const getMonthRange = (
    year,
    month
  ) => {
  
    const start =
      new Date(
        year,
        month,
        1,
        0,
        0,
        0,
        0
      );
  
  
    const end =
      new Date(
        year,
        month + 1,
        1,
        0,
        0,
        0,
        0
      );
  
  
    return {
      start,
      end,
    };
  
  };
  
  
  /* =========================================================
     GET MONTH NAME
  ========================================================= */
  
  const getMonthName = (
    year,
    month
  ) => {
  
    return new Date(
      year,
      month,
      1
    ).toLocaleString(
      undefined,
      {
        month: "long",
        year: "numeric",
      }
    );
  
  };
  
  
  /* =========================================================
     ADMIN MONTHLY BONUS
  ========================================================= */
  
  const AdminMonthlyBonus = () => {
  
  
    /* =======================================================
       CURRENT MONTH
    ======================================================= */
  
    const today =
      new Date();
  
  
    const [
      selectedYear,
      setSelectedYear,
    ] = useState(
      today.getFullYear()
    );
  
  
    const [
      selectedMonth,
      setSelectedMonth,
    ] = useState(
      today.getMonth()
    );
  
  
    /* =======================================================
       DATA
    ======================================================= */
  
    const [
      users,
      setUsers,
    ] = useState([]);
  
  
    const [
      visitorDeposits,
      setVisitorDeposits,
    ] = useState([]);
  
  
    const [
      transactions,
      setTransactions,
    ] = useState([]);
  
  
    const [
      bets,
      setBets,
    ] = useState([]);
  
  
    const [
      existingBonuses,
      setExistingBonuses,
    ] = useState([]);
  
  
    /* =======================================================
       UI
    ======================================================= */
  
    const [
      loading,
      setLoading,
    ] = useState(true);
  
  
    const [
      error,
      setError,
    ] = useState("");
  
  
    const [
      search,
      setSearch,
    ] = useState("");
  
  
    const [
      selectedUser,
      setSelectedUser,
    ] = useState(null);
  
  
    const [
      bonusAmount,
      setBonusAmount,
    ] = useState("");
  
  
    const [
      customBonus,
      setCustomBonus,
    ] = useState("");
  
  
    const [
      approving,
      setApproving,
    ] = useState(false);
  
  
    const [
      message,
      setMessage,
    ] = useState("");
  
  
    /* =======================================================
       LOAD DATA
    ======================================================= */
  
    useEffect(() => {
  
      loadAllData();
  
    }, [
      selectedYear,
      selectedMonth,
    ]);
  
  
    const loadAllData =
      async () => {
  
        setLoading(true);
  
        setError("");
  
        try {
  
          /* ===============================================
             USERS
          =============================================== */
  
          const usersSnap =
            await getDocs(
              collection(
                db,
                "users"
              )
            );
  
  
          const usersData =
            usersSnap.docs.map(
              (item) => ({
                id: item.id,
                ...item.data(),
              })
            );
  
  
          setUsers(
            usersData
          );
  
  
          /* ===============================================
             VISITOR DEPOSITS
          =============================================== */
  
          const visitorSnap =
            await getDocs(
              collection(
                db,
                "visterdeposte"
              )
            );
  
  
          const visitorData =
            visitorSnap.docs.map(
              (item) => ({
                id: item.id,
                ...item.data(),
              })
            );
  
  
          setVisitorDeposits(
            visitorData
          );
  
  
          /* ===============================================
             TSH TRANSACTIONS
          =============================================== */
  
          const tshSnap =
            await getDocs(
              collection(
                db,
                "tsh_transactions"
              )
            );
  
  
          const tshData =
            tshSnap.docs.map(
              (item) => ({
                id: item.id,
                collectionName:
                  "tsh_transactions",
                ...item.data(),
              })
            );
  
  
          /* ===============================================
             USDT TRANSACTIONS
          =============================================== */
  
          const usdtSnap =
            await getDocs(
              collection(
                db,
                "usdt_transactions"
              )
            );
  
  
          const usdtData =
            usdtSnap.docs.map(
              (item) => ({
                id: item.id,
                collectionName:
                  "usdt_transactions",
                ...item.data(),
              })
            );
  
  
          setTransactions([
            ...tshData,
            ...usdtData,
          ]);
  
  
          /* ===============================================
             ANT SCORE
          =============================================== */
  
          const betsSnap =
            await getDocs(
              collection(
                db,
                "antscore"
              )
            );
  
  
          const betsData =
            betsSnap.docs.map(
              (item) => ({
                id: item.id,
                ...item.data(),
              })
            );
  
  
          setBets(
            betsData
          );
  
  
          /* ===============================================
             MONTHLY BONUSES
          =============================================== */
  
          const monthKey =
            `${selectedYear}-${String(
              selectedMonth + 1
            ).padStart(2, "0")}`;
  
  
          const bonusQuery =
            query(
              collection(
                db,
                "monthly_bonuses"
              ),
              where(
                "monthKey",
                "==",
                monthKey
              )
            );
  
  
          const bonusSnap =
            await getDocs(
              bonusQuery
            );
  
  
          const bonusData =
            bonusSnap.docs.map(
              (item) => ({
                id: item.id,
                ...item.data(),
              })
            );
  
  
          setExistingBonuses(
            bonusData
          );
  
        }
  
        catch (err) {
  
          console.error(
            "Monthly bonus loading error:",
            err
          );
  
  
          setError(
            err?.message ||
            "Imeshindikana kupakia taarifa."
          );
  
        }
  
        finally {
  
          setLoading(false);
  
        }
  
      };
  
  
    /* =======================================================
       BUILD REFERRAL MAP
    ======================================================= */
  
    const referralMap =
      useMemo(() => {
  
        const map = {};
  
        users.forEach(
          (user) => {
  
            if (
              user.username
            ) {
  
              map[
                String(
                  user.username
                ).trim()
                .toLowerCase()
              ] =
                user.username;
  
            }
  
            if (
              user.referralCode
            ) {
  
              map[
                String(
                  user.referralCode
                ).trim()
                .toLowerCase()
              ] =
                user.username;
  
            }
  
          }
        );
  
  
        return map;
  
      }, [users]);
  
  
    /* =======================================================
       GET REFERRER USERNAME
    ======================================================= */
  
    const getReferrerUsername =
      (user) => {
  
        if (
          !user.referralBy
        ) {
          return null;
        }
  
  
        const referralValue =
          String(
            user.referralBy
          )
          .trim()
          .toLowerCase();
  
  
        return (
          referralMap[
            referralValue
          ] ||
          null
        );
  
      };
  
  
    /* =======================================================
       MONTH RANGE
    ======================================================= */
  
    const monthRange =
      useMemo(() => {
  
        return getMonthRange(
          selectedYear,
          selectedMonth
        );
  
      }, [
        selectedYear,
        selectedMonth,
      ]);
  
  
    /* =======================================================
       MONTH TRANSACTIONS
    ======================================================= */
  
    const monthTransactions =
      useMemo(() => {
  
        return transactions.filter(
          (tx) => {
  
            const date =
              getTransactionDate(
                tx
              );
  
  
            if (!date) {
              return false;
            }
  
  
            return (
              date >=
                monthRange.start &&
              date <
                monthRange.end &&
              tx.status ===
                "success"
            );
  
          }
        );
  
      }, [
        transactions,
        monthRange,
      ]);
  
  
    /* =======================================================
       MONTH VISITOR DEPOSITS
    ======================================================= */
  
    const monthVisitorDeposits =
      useMemo(() => {
  
        return visitorDeposits.filter(
          (deposit) => {
  
            const date =
              getTransactionDate(
                deposit
              );
  
  
            if (!date) {
              return false;
            }
  
  
            return (
              date >=
                monthRange.start &&
              date <
                monthRange.end &&
              deposit.status ===
                "success"
            );
  
          }
        );
  
      }, [
        visitorDeposits,
        monthRange,
      ]);
  
  
    /* =======================================================
       USER DEPOSIT RECORDS
    ======================================================= */
  
    const getUserDeposits =
      (username) => {
  
        const result = [];
  
  
        /* ===============================================
           VISITOR DEPOSITS
        =============================================== */
  
        monthVisitorDeposits
          .filter(
            (deposit) =>
              String(
                deposit.username ||
                ""
              )
              .toLowerCase() ===
              String(
                username ||
                ""
              )
              .toLowerCase()
          )
          .forEach(
            (deposit) => {
  
              const tzs =
                convertToTZS(
                  deposit.amount,
                  deposit.country,
                  countryCurrency[
                    deposit.country
                  ]
                );
  
  
              result.push({
                ...deposit,
                source:
                  "visitor",
                tzsValue:
                  tzs,
              });
  
            }
          );
  
  
        /* ===============================================
           TSH / USDT TRANSACTIONS
        =============================================== */
  
        monthTransactions
          .filter(
            (tx) =>
              String(
                tx.username ||
                ""
              )
              .toLowerCase() ===
              String(
                username ||
                ""
              )
              .toLowerCase()
          )
          .forEach(
            (tx) => {
  
              let tzs = 0;
  
  
              if (
                tx.collectionName ===
                "tsh_transactions"
              ) {
  
                tzs =
                  convertToTZS(
                    tx.amount,
                    null,
                    "TZS"
                  );
  
              }
  
  
              result.push({
                ...tx,
                source:
                  tx.collectionName,
                tzsValue:
                  tzs,
              });
  
            }
          );
  
  
        return result;
  
      };
  
  
    /* =======================================================
       GET USER PLAY DATA
    ======================================================= */
  
    const getUserPlayData =
      (username) => {
  
        const userBets =
          bets.filter(
            (bet) => {
  
              const betUsername =
                String(
                  bet.username ||
                  ""
                )
                .trim()
                .toLowerCase();
  
  
              const targetUsername =
                String(
                  username ||
                  ""
                )
                .trim()
                .toLowerCase();
  
  
              if (
                betUsername !==
                targetUsername
              ) {
                return false;
              }
  
  
              const date =
                getTransactionDate(
                  bet
                );
  
  
              if (!date) {
                return false;
              }
  
  
              return (
                date >=
                  monthRange.start &&
                date <
                  monthRange.end
              );
  
            }
          );
  
  
        /* ===============================================
           UNIQUE PLAY DAYS
        =============================================== */
  
        const days =
          new Set();
  
  
        userBets.forEach(
          (bet) => {
  
            const date =
              getTransactionDate(
                bet
              );
  
  
            if (!date) {
              return;
            }
  
  
            const key =
              `${date.getFullYear()}-${String(
                date.getMonth() + 1
              ).padStart(2, "0")}-${String(
                date.getDate()
              ).padStart(2, "0")}`;
  
  
            days.add(
              key
            );
  
          }
        );
  
  
        return {
          bets:
            userBets.length,
  
          playDays:
            days.size,
        };
  
      };
  
  
    /* =======================================================
       BUILD CANDIDATES
    ======================================================= */
  
    const candidates =
      useMemo(() => {
  
        return users
          .filter(
            (user) =>
              user.username
          )
          .map(
            (user) => {
  
              const username =
                user.username;
  
  
              /* =========================================
                 LEVEL 1
              ========================================= */
  
              const level1Users =
                users.filter(
                  (child) => {
  
                    const referrer =
                      getReferrerUsername(
                        child
                      );
  
  
                    return (
                      referrer &&
                      String(
                        referrer
                      )
                      .toLowerCase() ===
                      String(
                        username
                      )
                      .toLowerCase()
                    );
  
                  }
                );
  
  
              /* =========================================
                 LEVEL 1 QUALIFIED
              ========================================= */
  
              const level1Details =
                level1Users.map(
                  (child) => {
  
                    const childDeposits =
                      getUserDeposits(
                        child.username
                      );
  
  
                    const totalDepositTZS =
                      childDeposits.reduce(
                        (
                          sum,
                          deposit
                        ) =>
                          sum +
                          Number(
                            deposit.tzsValue ||
                            0
                          ),
                        0
                      );
  
  
                    /*
                     * User huyo anakuwa qualified
                     * kama mwezi huu ameweka >= 30,000 TZS.
                     */
  
                    const qualified =
                      totalDepositTZS >=
                      MIN_LEVEL1_DEPOSIT_TZS;
  
  
                    return {
                      username:
                        child.username,
  
                      totalDepositTZS,
  
                      qualified,
                    };
  
                  }
                );
  
  
              const qualifiedLevel1 =
                level1Details.filter(
                  (item) =>
                    item.qualified
                );
  
  
              /* =========================================
                 MAIN USER DEPOSITS
              ========================================= */
  
              const userDeposits =
                getUserDeposits(
                  username
                );
  
  
              const depositCount =
                userDeposits.length;
  
  
              const totalDepositTZS =
                userDeposits.reduce(
                  (
                    sum,
                    deposit
                  ) =>
                    sum +
                    Number(
                      deposit.tzsValue ||
                      0
                    ),
                  0
                );
  
  
              /* =========================================
                 PLAY DATA
              ========================================= */
  
              const playData =
                getUserPlayData(
                  username
                );
  
  
              /* =========================================
                 ELIGIBILITY
              ========================================= */
  
              const level1Eligible =
                qualifiedLevel1.length >=
                MIN_LEVEL1;
  
  
              const depositsEligible =
                depositCount >=
                MIN_USER_DEPOSITS;
  
  
              /*
               * Hapa tunafanya gaming activity
               * kuwa information muhimu.
               *
               * Hatulazimishi siku fulani kwa sababu
               * haukutoa number exact ya gaming days.
               */
  
              const gamingActive =
                playData.playDays > 0;
  
  
              const eligible =
                level1Eligible &&
                depositsEligible &&
                gamingActive;
  
  
              /* =========================================
                 SCORE
              ========================================= */
  
              let score = 0;
  
  
              if (
                level1Eligible
              ) {
                score += 40;
              }
  
  
              if (
                depositsEligible
              ) {
                score += 30;
              }
  
  
              if (
                gamingActive
              ) {
                score += 30;
              }
  
  
              return {
  
                id:
                  user.id,
  
                username,
  
                level1Count:
                  level1Users.length,
  
                qualifiedLevel1Count:
                  qualifiedLevel1.length,
  
                level1Details,
  
                depositCount,
  
                totalDepositTZS,
  
                playDays:
                  playData.playDays,
  
                betCount:
                  playData.bets,
  
                score,
  
                eligible,
  
              };
  
            }
          )
          .sort(
            (a, b) => {
  
              /*
               * Highest score first
               */
  
              if (
                b.score !==
                a.score
              ) {
  
                return (
                  b.score -
                  a.score
                );
  
              }
  
  
              /*
               * Then qualified referrals
               */
  
              if (
                b.qualifiedLevel1Count !==
                a.qualifiedLevel1Count
              ) {
  
                return (
                  b.qualifiedLevel1Count -
                  a.qualifiedLevel1Count
                );
  
              }
  
  
              /*
               * Then play days
               */
  
              return (
                b.playDays -
                a.playDays
              );
  
            }
          );
  
      }, [
        users,
        monthVisitorDeposits,
        monthTransactions,
        bets,
        referralMap,
        monthRange,
      ]);
  
  
    /* =======================================================
       FILTER SEARCH
    ======================================================= */
  
    const filteredCandidates =
      candidates.filter(
        (candidate) =>
          candidate.username
            .toLowerCase()
            .includes(
              search.toLowerCase()
            )
      );
  
  
    /* =======================================================
       SUMMARY
    ======================================================= */
  
    const eligibleCount =
      candidates.filter(
        (item) =>
          item.eligible
      ).length;
  
  
    const totalCandidates =
      candidates.length;
  
  
    const approvedCount =
      existingBonuses.length;
  
  
    /* =======================================================
       BONUS OPTIONS
    ======================================================= */
  
    const bonusOptions = [
      5000,
      10000,
      20000,
      30000,
      50000,
      100000,
    ];
  
  
    /* =======================================================
       OPEN BONUS
    ======================================================= */
  
    const openBonus =
      (candidate) => {
  
        setSelectedUser(
          candidate
        );
  
        setBonusAmount("");
  
        setCustomBonus("");
  
        setMessage("");
  
      };
  
  
    /* =======================================================
       CLOSE BONUS
    ======================================================= */
  
    const closeBonus =
      () => {
  
        if (
          approving
        ) {
          return;
        }
  
  
        setSelectedUser(
          null
        );
  
        setBonusAmount("");
  
        setCustomBonus("");
  
      };
  
  
    /* =======================================================
       APPROVE BONUS
    ======================================================= */
  
    const approveBonus =
      async () => {
  
        if (
          !selectedUser
        ) {
          return;
        }
  
  
        let amount = 0;
  
  
        if (
          bonusAmount ===
          "custom"
        ) {
  
          amount =
            Number(
              customBonus
            );
  
        }
  
        else {
  
          amount =
            Number(
              bonusAmount
            );
  
        }
  
  
        if (
          !amount ||
          amount <= 0
        ) {
  
          setMessage(
            "Weka kiasi sahihi cha bonus."
          );
  
          return;
  
        }
  
  
        /*
         * CHECK ALREADY APPROVED
         */
  
        const alreadyApproved =
          existingBonuses.some(
            (bonus) =>
              String(
                bonus.username
              ).toLowerCase() ===
              String(
                selectedUser.username
              ).toLowerCase()
          );
  
  
        if (
          alreadyApproved
        ) {
  
          setMessage(
            "User huyu tayari amepewa bonus mwezi huu."
          );
  
          return;
  
        }
  
  
        setApproving(
          true
        );
  
  
        try {
  
          const monthKey =
            `${selectedYear}-${String(
              selectedMonth + 1
            ).padStart(2, "0")}`;
  
  
          /* =============================================
             SAVE BONUS
          ============================================= */
  
          await addDoc(
            collection(
              db,
              "monthly_bonuses"
            ),
            {
  
              username:
                selectedUser.username,
  
              monthKey,
  
              month:
                selectedMonth + 1,
  
              year:
                selectedYear,
  
              level1Count:
                selectedUser.level1Count,
  
              qualifiedLevel1Count:
                selectedUser.qualifiedLevel1Count,
  
              depositCount:
                selectedUser.depositCount,
  
              totalDepositTZS:
                selectedUser.totalDepositTZS,
  
              playDays:
                selectedUser.playDays,
  
              betCount:
                selectedUser.betCount,
  
              score:
                selectedUser.score,
  
              bonusAmount:
                amount,
  
              currency:
                "TZS",
  
              status:
                "approved",
  
              approvedAt:
                serverTimestamp(),
  
              source:
                "AdminMonthlyBonus",
  
            }
          );
  
  
          setMessage(
            `✅ Bonus ya ${formatNumber(
              amount
            )} TZS imeidhinishwa kwa ${
              selectedUser.username
            }.`
          );
  
  
          setSelectedUser(
            null
          );
  
  
          setBonusAmount("");
  
          setCustomBonus("");
  
  
          /*
           * RELOAD DATA
           */
  
          await loadAllData();
  
        }
  
        catch (err) {
  
          console.error(
            "Approve bonus error:",
            err
          );
  
  
          setMessage(
            err?.message ||
            "Imeshindikana ku-save bonus."
          );
  
        }
  
        finally {
  
          setApproving(
            false
          );
  
        }
  
      };
  
  
    /* =======================================================
       YEAR OPTIONS
    ======================================================= */
  
    const yearOptions = [];
  
    for (
      let year =
        today.getFullYear() - 2;
      year <=
        today.getFullYear() + 1;
      year++
    ) {
  
      yearOptions.push(
        year
      );
  
    }
  
  
    /* =======================================================
       LOADING
    ======================================================= */
  
    if (
      loading
    ) {
  
      return (
  
        <div className="monthly-bonus-page">
  
          <div className="monthly-bonus-loading">
  
            <div className="monthly-bonus-spinner" />
  
            <h3>
              Loading Monthly Bonus...
            </h3>
  
            <p>
              Inakusanya users, deposits
              na gaming activity.
            </p>
  
          </div>
  
        </div>
  
      );
  
    }
  
  
    /* =======================================================
       UI
    ======================================================= */
  
    return (
  
      <div className="monthly-bonus-page">
  
        <div className="monthly-bonus-container">
  
  
          {/* =================================================
              HEADER
          ================================================= */}
  
          <div className="monthly-bonus-header">
  
            <div>
  
              <span className="eyebrow">
                ADMIN REWARD SYSTEM
              </span>
  
              <h1>
                Monthly Bonus
              </h1>
  
              <p>
                Chagua users wanaostahili
                bonus kutokana na performance
                yao ya mwezi.
              </p>
  
            </div>
  
  
            <div className="month-selector">
  
              <label>
                MONTH
              </label>
  
              <div className="month-controls">
  
                <select
                  value={
                    selectedMonth
                  }
                  onChange={(e) =>
                    setSelectedMonth(
                      Number(
                        e.target.value
                      )
                    )
                  }
                >
  
                  {Array.from(
                    {
                      length: 12,
                    },
                    (
                      _,
                      index
                    ) => (
  
                      <option
                        key={
                          index
                        }
                        value={
                          index
                        }
                      >
                        {new Date(
                          2000,
                          index,
                          1
                        ).toLocaleString(
                          undefined,
                          {
                            month:
                              "long",
                          }
                        )}
                      </option>
  
                    )
                  )}
  
                </select>
  
  
                <select
                  value={
                    selectedYear
                  }
                  onChange={(e) =>
                    setSelectedYear(
                      Number(
                        e.target.value
                      )
                    )
                  }
                >
  
                  {yearOptions.map(
                    (year) => (
  
                      <option
                        key={
                          year
                        }
                        value={
                          year
                        }
                      >
                        {year}
                      </option>
  
                    )
                  )}
  
                </select>
  
              </div>
  
            </div>
  
          </div>
  
  
          {/* =================================================
              MESSAGE
          ================================================= */}
  
          {message && (
  
            <div className="monthly-bonus-message">
  
              {message}
  
            </div>
  
          )}
  
  
          {/* =================================================
              ERROR
          ================================================= */}
  
          {error && (
  
            <div className="monthly-bonus-error">
  
              ⚠️ {error}
  
            </div>
  
          )}
  
  
          {/* =================================================
              SUMMARY
          ================================================= */}
  
          <div className="monthly-summary-grid">
  
            <div className="monthly-summary-card">
  
              <span>
                TOTAL USERS
              </span>
  
              <strong>
                {formatNumber(
                  totalCandidates
                )}
              </strong>
  
            </div>
  
  
            <div className="monthly-summary-card eligible-card">
  
              <span>
                ELIGIBLE
              </span>
  
              <strong>
                {formatNumber(
                  eligibleCount
                )}
              </strong>
  
            </div>
  
  
            <div className="monthly-summary-card">
  
              <span>
                BONUS APPROVED
              </span>
  
              <strong>
                {formatNumber(
                  approvedCount
                )}
              </strong>
  
            </div>
  
  
            <div className="monthly-summary-card">
  
              <span>
                MONTH
              </span>
  
              <strong className="month-card-name">
                {getMonthName(
                  selectedYear,
                  selectedMonth
                )}
              </strong>
  
            </div>
  
          </div>
  
  
          {/* =================================================
              CRITERIA
          ================================================= */}
  
          <div className="criteria-card">
  
            <div className="criteria-title">
  
              <span>
                BONUS CRITERIA
              </span>
  
              <h2>
                Mfumo wa kuchagua candidates
              </h2>
  
            </div>
  
  
            <div className="criteria-grid">
  
              <div>
  
                <b>
                  01
                </b>
  
                <strong>
                  Level 1
                </strong>
  
                <span>
                  Angalau {MIN_LEVEL1}
                  {" "}Level 1 qualified users
                </span>
  
              </div>
  
  
              <div>
  
                <b>
                  02
                </b>
  
                <strong>
                  Deposit
                </strong>
  
                <span>
                  Level 1 lazima awe na
                  deposit ≥{" "}
                  {formatNumber(
                    MIN_LEVEL1_DEPOSIT_TZS
                  )} TZS
                </span>
  
              </div>
  
  
              <div>
  
                <b>
                  03
                </b>
  
                <strong>
                  Main Deposits
                </strong>
  
                <span>
                  User awe na angalau{" "}
                  {MIN_USER_DEPOSITS}
                  {" "}deposits mwezi huu
                </span>
  
              </div>
  
  
              <div>
  
                <b>
                  04
                </b>
  
                <strong>
                  Gaming
                </strong>
  
                <span>
                  Awe na gaming activity
                  ndani ya mwezi
                </span>
  
              </div>
  
            </div>
  
          </div>
  
  
          {/* =================================================
              SEARCH
          ================================================= */}
  
          <div className="candidate-toolbar">
  
            <div>
  
              <span>
                CANDIDATES
              </span>
  
              <h2>
                Monthly Performance
              </h2>
  
            </div>
  
  
            <input
              type="text"
              placeholder="Search username..."
              value={
                search
              }
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
            />
  
          </div>
  
  
          {/* =================================================
              TABLE
          ================================================= */}
  
          <div className="monthly-table-wrapper">
  
            <table className="monthly-bonus-table">
  
              <thead>
  
                <tr>
  
                  <th>
                    #
                  </th>
  
                  <th>
                    USER
                  </th>
  
                  <th>
                    LEVEL 1
                  </th>
  
                  <th>
                    QUALIFIED L1
                  </th>
  
                  <th>
                    DEPOSITS
                  </th>
  
                  <th>
                    TOTAL DEPOSIT
                  </th>
  
                  <th>
                    PLAY DAYS
                  </th>
  
                  <th>
                    BETS
                  </th>
  
                  <th>
                    SCORE
                  </th>
  
                  <th>
                    STATUS
                  </th>
  
                  <th>
                    BONUS
                  </th>
  
                </tr>
  
              </thead>
  
  
              <tbody>
  
                {filteredCandidates.length ===
                0 ? (
  
                  <tr>
  
                    <td
                      colSpan="11"
                      className="empty-table"
                    >
                      Hakuna users waliopatikana.
                    </td>
  
                  </tr>
  
                ) : (
  
                  filteredCandidates.map(
                    (
                      candidate,
                      index
                    ) => {
  
                      const alreadyApproved =
                        existingBonuses.some(
                          (bonus) =>
                            String(
                              bonus.username
                            ).toLowerCase() ===
                            String(
                              candidate.username
                            ).toLowerCase()
                        );
  
  
                      return (
  
                        <tr
                          key={
                            candidate.id ||
                            candidate.username
                          }
                          className={
                            candidate.eligible
                              ? "eligible-row"
                              : ""
                          }
                        >
  
                          <td>
                            {index + 1}
                          </td>
  
  
                          <td>
  
                            <div className="username-cell">
  
                              <strong>
                                {
                                  candidate.username
                                }
                              </strong>
  
                              {candidate.eligible && (
  
                                <small>
                                  RECOMMENDED
                                </small>
  
                              )}
  
                            </div>
  
                          </td>
  
  
                          <td>
  
                            <strong>
                              {
                                candidate.level1Count
                              }
                            </strong>
  
                          </td>
  
  
                          <td>
  
                            <strong
                              className={
                                candidate.qualifiedLevel1Count >=
                                MIN_LEVEL1
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {
                                candidate.qualifiedLevel1Count
                              }
                            </strong>
  
                            <span>
                              {" "}/{" "}
                              {MIN_LEVEL1}
                            </span>
  
                          </td>
  
  
                          <td>
  
                            <strong
                              className={
                                candidate.depositCount >=
                                MIN_USER_DEPOSITS
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {
                                candidate.depositCount
                              }
                            </strong>
  
                          </td>
  
  
                          <td>
  
                            {formatNumber(
                              candidate.totalDepositTZS
                            )}
  
                            {" "}TZS
  
                          </td>
  
  
                          <td>
  
                            <strong>
                              {
                                candidate.playDays
                              }
                            </strong>
  
                            {" "}days
  
                          </td>
  
  
                          <td>
  
                            {
                              candidate.betCount
                            }
  
                          </td>
  
  
                          <td>
  
                            <div className="score-box">
  
                              {candidate.score}
                              %
  
                            </div>
  
                          </td>
  
  
                          <td>
  
                            {candidate.eligible ? (
  
                              <span className="status-badge status-eligible">
                                ✓ ELIGIBLE
                              </span>
  
                            ) : (
  
                              <span className="status-badge status-partial">
                                PARTIAL
                              </span>
  
                            )}
  
                          </td>
  
  
                          <td>
  
                            {alreadyApproved ? (
  
                              <span className="approved-badge">
                                ✓ APPROVED
                              </span>
  
                            ) : (
  
                              <button
                                type="button"
                                className={
                                  candidate.eligible
                                    ? "choose-bonus-btn"
                                    : "review-bonus-btn"
                                }
                                onClick={() =>
                                  openBonus(
                                    candidate
                                  )
                                }
                              >
  
                                {candidate.eligible
                                  ? "CHOOSE BONUS"
                                  : "REVIEW"}
  
                              </button>
  
                            )}
  
                          </td>
  
                        </tr>
  
                      );
  
                    }
                  )
  
                )}
  
              </tbody>
  
            </table>
  
          </div>
  
  
          {/* =================================================
              DETAILS MODAL
          ================================================= */}
  
          {selectedUser && (
  
            <div
              className="bonus-modal-overlay"
              onClick={
                closeBonus
              }
            >
  
              <div
                className="bonus-modal"
                onClick={(event) =>
                  event.stopPropagation()
                }
              >
  
  
                {/* HEADER */}
  
                <div className="bonus-modal-header">
  
                  <div>
  
                    <span>
                      USER PERFORMANCE
                    </span>
  
                    <h2>
                      {
                        selectedUser.username
                      }
                    </h2>
  
                  </div>
  
  
                  <button
                    type="button"
                    className="close-modal"
                    onClick={
                      closeBonus
                    }
                  >
                    ×
                  </button>
  
                </div>
  
  
                {/* PERFORMANCE */}
  
                <div className="performance-grid">
  
                  <div>
  
                    <span>
                      LEVEL 1
                    </span>
  
                    <strong>
                      {
                        selectedUser.level1Count
                      }
                    </strong>
  
                  </div>
  
  
                  <div>
  
                    <span>
                      QUALIFIED L1
                    </span>
  
                    <strong>
                      {
                        selectedUser.qualifiedLevel1Count
                      }
                    </strong>
  
                  </div>
  
  
                  <div>
  
                    <span>
                      DEPOSITS
                    </span>
  
                    <strong>
                      {
                        selectedUser.depositCount
                      }
                    </strong>
  
                  </div>
  
  
                  <div>
  
                    <span>
                      PLAY DAYS
                    </span>
  
                    <strong>
                      {
                        selectedUser.playDays
                      }
                    </strong>
  
                  </div>
  
  
                  <div>
  
                    <span>
                      BETS
                    </span>
  
                    <strong>
                      {
                        selectedUser.betCount
                      }
                    </strong>
  
                  </div>
  
  
                  <div>
  
                    <span>
                      SCORE
                    </span>
  
                    <strong>
                      {
                        selectedUser.score
                      }%
                    </strong>
  
                  </div>
  
                </div>
  
  
                {/* DEPOSIT */}
  
                <div className="modal-deposit-box">
  
                  <span>
                    TOTAL DEPOSIT THIS MONTH
                  </span>
  
                  <strong>
                    {formatNumber(
                      selectedUser.totalDepositTZS
                    )} TZS
                  </strong>
  
                </div>
  
  
                {/* LEVEL 1 DETAILS */}
  
                <div className="level1-modal-section">
  
                  <div className="modal-section-title">
  
                    <span>
                      LEVEL 1 MEMBERS
                    </span>
  
                    <strong>
                      {
                        selectedUser.level1Count
                      }
                    </strong>
  
                  </div>
  
  
                  {selectedUser.level1Details
                    .length === 0 ? (
  
                    <p className="modal-empty">
                      Hakuna Level 1.
                    </p>
  
                  ) : (
  
                    <div className="level1-list">
  
                      {selectedUser.level1Details.map(
                        (
                          child
                        ) => (
  
                          <div
                            key={
                              child.username
                            }
                            className="level1-item"
                          >
  
                            <div>
  
                              <strong>
                                {
                                  child.username
                                }
                              </strong>
  
                              <span>
                                {formatNumber(
                                  child.totalDepositTZS
                                )} TZS
                              </span>
  
                            </div>
  
  
                            {child.qualified ? (
  
                              <span className="child-qualified">
                                ✓ QUALIFIED
                              </span>
  
                            ) : (
  
                              <span className="child-not-qualified">
                                NOT QUALIFIED
                              </span>
  
                            )}
  
                          </div>
  
                        )
                      )}
  
                    </div>
  
                  )}
  
                </div>
  
  
                {/* CRITERIA CHECK */}
  
                <div className="criteria-check">
  
                  <div>
  
                    <span>
                      Level 1 requirement
                    </span>
  
                    {selectedUser.qualifiedLevel1Count >=
                    MIN_LEVEL1 ? (
                      <b className="check-ok">
                        ✓ PASS
                      </b>
                    ) : (
                      <b className="check-no">
                        ✕ FAIL
                      </b>
                    )}
  
                  </div>
  
  
                  <div>
  
                    <span>
                      Deposit requirement
                    </span>
  
                    {selectedUser.depositCount >=
                    MIN_USER_DEPOSITS ? (
                      <b className="check-ok">
                        ✓ PASS
                      </b>
                    ) : (
                      <b className="check-no">
                        ✕ FAIL
                      </b>
                    )}
  
                  </div>
  
  
                  <div>
  
                    <span>
                      Gaming activity
                    </span>
  
                    {selectedUser.playDays > 0 ? (
                      <b className="check-ok">
                        ✓ PASS
                      </b>
                    ) : (
                      <b className="check-no">
                        ✕ FAIL
                      </b>
                    )}
  
                  </div>
  
                </div>
  
  
                {/* BONUS SELECTOR */}
  
                <div className="bonus-selector">
  
                  <span className="bonus-selector-label">
                    CHOOSE BONUS AMOUNT
                  </span>
  
  
                  <div className="bonus-options">
  
                    {bonusOptions.map(
                      (amount) => (
  
                        <button
                          key={
                            amount
                          }
                          type="button"
                          className={
                            bonusAmount ===
                            String(
                              amount
                            )
                              ? "bonus-option selected"
                              : "bonus-option"
                          }
                          onClick={() =>
                            setBonusAmount(
                              String(
                                amount
                              )
                            )
                          }
                        >
  
                          {formatNumber(
                            amount
                          )}
  
                          {" "}TZS
  
                        </button>
  
                      )
                    )}
  
  
                    <button
                      type="button"
                      className={
                        bonusAmount ===
                        "custom"
                          ? "bonus-option selected"
                          : "bonus-option"
                      }
                      onClick={() =>
                        setBonusAmount(
                          "custom"
                        )
                      }
                    >
  
                      CUSTOM
  
                    </button>
  
                  </div>
  
  
                  {bonusAmount ===
                    "custom" && (
  
                    <input
                      type="number"
                      min="1"
                      placeholder="Enter custom bonus"
                      value={
                        customBonus
                      }
                      onChange={(e) =>
                        setCustomBonus(
                          e.target.value
                        )
                      }
                      className="custom-bonus-input"
                    />
  
                  )}
  
                </div>
  
  
                {/* MODAL MESSAGE */}
  
                {message && (
  
                  <div className="modal-message">
  
                    {message}
  
                  </div>
  
                )}
  
  
                {/* APPROVE */}
  
                <div className="modal-actions">
  
                  <button
                    type="button"
                    className="cancel-bonus-btn"
                    onClick={
                      closeBonus
                    }
                    disabled={
                      approving
                    }
                  >
                    CANCEL
                  </button>
  
  
                  <button
                    type="button"
                    className="approve-bonus-btn"
                    onClick={
                      approveBonus
                    }
                    disabled={
                      approving
                    }
                  >
  
                    {approving
                      ? "SAVING..."
                      : "✓ APPROVE BONUS"}
  
                  </button>
  
                </div>
  
              </div>
  
            </div>
  
          )}
  
        </div>
  
      </div>
  
    );
  
  };
  
  
  export default AdminMonthlyBonus;